module.exports = ".obrigatorio {\r\n  font-weight: 600;\r\n}\r\n.obrigatorio::before {\r\n  content: \"*\";\r\n  color: red;\r\n  font-weight: 600;\r\n  padding-right: 2px;\r\n}\r\n"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/candidato/inscricao-form/inscricao-form.component.css
// module id = ./src/app/components/candidato/inscricao-form/inscricao-form.component.css
// module chunks = main